export const images = [
  {
    url: "./images/home/banner--004.jpg",
    title: "CONVIÉRTETE EN EXPERTO FLEISCHMANN",
    subtitle: "Espéralo muy pronto",
  },
];

export const navidadImgs = [
  {
    url: "./images/home/BannersPaginaNav.jpg",
    title: null,
    subtitle: null,
    activeButton: false,
  },
];

export const lanzamientoimg = {
  url: "./images/home/BannersPaginaNav.jpg",
  title: "CONVIÉRTETE EN EXPERTO FLEISCHMANN",
  subtitle: "Espéralo muy pronto",
};

export const imgs = [
  {
    url: "./images/home/banner--001.jpg",
    title: "DEMOSTRACIONES",
    subtitle: "de producto",
  },
  {
    url: "./images/home/banner--002.jpg",
    title: "CAPACITACIONES",
    subtitle: "por expertos",
    style: {
      objectPosition: "center top",
    },
  },
  {
    url: "./images/home/banner--003.jpg",
    title: "FORMACIÓN",
    subtitle: "en Panadería y Pastelería",
  },
];
